import CONSTANTS from '../constants';

export default class NotificationHelper {
  static isOrderReview(notification) {
    return (
      notification.Order &&
      notification.Location &&
      notification.type === CONSTANTS.NOTIFICATIONS.VARIABLES.TYPES.ORDER_REVIEW
    );
  }
}
